import { useSyncExternalStore, useMemo, useRef } from "react";
import { OrderService } from "@domain/services/order.service";

export function useOrders() {
  // Кэшируем store для стабильности ссылки
  const storeRef = useRef(OrderService.getStore());
  const store = storeRef.current;
  
  // Создаем стабильную функцию getSnapshot с мемоизацией результата
  const snapshotRef = useRef<ReturnType<typeof store.getState>>();
  const getSnapshotRef = useRef(() => {
    const newSnapshot = store.getState();
    // Если массивы имеют ту же длину и те же order_number, возвращаем старую ссылку
    if (snapshotRef.current) {
      const old = snapshotRef.current;
      const newState = newSnapshot;
      
      // Сравниваем orderHistory
      const orderHistoryChanged = 
        old.orderHistory.length !== newState.orderHistory.length ||
        old.orderHistory.some((order, i) => 
          !newState.orderHistory[i] || 
          order.order_number !== newState.orderHistory[i].order_number
        );
      
      // Сравниваем activeOrders (включая status и time_to_ready)
      const activeOrdersChanged = 
        old.activeOrders.length !== newState.activeOrders.length ||
        old.activeOrders.some((order, i) => {
          const newOrder = newState.activeOrders[i];
          return !newOrder || 
            order.order_number !== newOrder.order_number ||
            order.status !== newOrder.status ||
            order.time_to_ready !== newOrder.time_to_ready ||
            order.status_description !== newOrder.status_description;
        });
      
      if (!orderHistoryChanged && !activeOrdersChanged) {
        return snapshotRef.current;
      }
    }
    snapshotRef.current = newSnapshot;
    return newSnapshot;
  });
  const getSnapshot = getSnapshotRef.current;
  
  const state = useSyncExternalStore(store.subscribe, getSnapshot);

  const actions = useMemo(
    () => ({
      // ИЗМЕНЕНО: убрали автоматический polling, добавили ручное обновление
      refreshOrderHistory: OrderService.fetchOrderHistory.bind(OrderService),
      startBackgroundPolling: OrderService.startBackgroundPolling.bind(OrderService),
      stopBackgroundPolling: OrderService.stopBackgroundPolling.bind(OrderService)
    }),
    []
  );

  return {
    orderHistory: state.orderHistory,
    activeOrders: state.activeOrders,
    ...actions
  };
}
